import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 460px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 48px 40px;
  text-align: center;
`;

const Icon = styled.div`
  font-size: 52px;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 12px;
`;

const Body = styled.p`
  font-size: 15px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
`;

const Note = styled.p`
  font-size: 13px;
  color: #9ca3af;
  margin: 16px 0 0;
`;

const BackLink = styled.a`
  display: inline-block;
  margin-top: 28px;
  padding: 11px 28px;
  background: #2563eb;
  color: white;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  &:hover { background: #1d4ed8; }
`;

const PaymentCancel: React.FC = () => (
  <Wrapper>
    <Card>
      <Icon>↩️</Icon>
      <Title>Payment cancelled</Title>
      <Body>Your payment was not completed and no charge was made.</Body>
      <Note>You can go back and try again whenever you're ready.</Note>
      <BackLink href="/signup">Back to Sign Up</BackLink>
    </Card>
  </Wrapper>
);

export default PaymentCancel;
